import React, { Fragment } from 'react';

const SelectedItem = (props) => {

    return (
        <Fragment>
            <div className="col-lg-4 col-md-6 col-xs-12">
                <p className="variable text-left">{props.TopVentas}</p>
                <h4>{props.Nombre}</h4>
                <p className="cod">Código: {props.Id}</p>
                <p className="tiempo">{props.CantidadPedidos} pedidos</p>
            </div>
            <div className="col-lg-8 col-md-6 col-xs-12">
                <img className="image-product-preview" src={props.Imagen} />
            </div>
        </Fragment>
    );

}
export default SelectedItem;